import dayjs from "dayjs";

export const calendarPeriod = (year) => ({
  start: dayjs(`${year}-01-01`),
  end: dayjs(`${year}-12-31`),
});

export const toReportingPeriod = (baseStartDate, baseEndDate, year) => {
  const start = dayjs(baseStartDate);
  const end = dayjs(baseEndDate);
  if (!baseStartDate || !baseEndDate || !start.isValid() || !end.isValid()) {
    return calendarPeriod(year);
  }
  return { start, end };
};

export const isDateInPeriod = (date, period) =>
  !date.isBefore(period.start, "day") && !date.isAfter(period.end, "day");

export const isMonthInPeriod = (date, period) =>
  !date.endOf("month").isBefore(period.start, "day") &&
  !date.startOf("month").isAfter(period.end, "day");

export const isYearInPeriod = (date, period) =>
  !date.endOf("year").isBefore(period.start, "day") &&
  !date.startOf("year").isAfter(period.end, "day");

export const pickerBounds = (year) => ({
  minDate: dayjs(`${year - 1}-01-01`),
  maxDate: dayjs(`${year + 1}-12-31`),
});

export const periodEndFromStart = (start) =>
  dayjs(start).add(1, "year").subtract(1, "day").format("YYYY-MM-DD");

// 數據清單分組的 timeIndex：月／日數據 "2025-3"（舊版後端只給月份 "3"）、年數據 "2026"、跨年區間 "2025 ~ 2026"
export const parseMonthTimeIndex = (timeIndex) => {
  const match = /^(?:(\d{4})-)?(\d{1,2})$/.exec(String(timeIndex).trim());
  const month = Number(match?.[2]);
  if (!match || month < 1 || month > 12) return null;
  return { year: match[1] ? Number(match[1]) : null, month };
};

export const timeIndexSortKey = (timeIndex) => {
  const parsed = parseMonthTimeIndex(timeIndex);
  if (parsed) return (parsed.year ?? 0) * 100 + parsed.month;
  return (parseInt(timeIndex, 10) || 0) * 100;
};
